import { render, staticRenderFns } from "./projects-dialog.vue?vue&type=template&id=00a3f0db&"
import script from "./projects-dialog.vue?vue&type=script&lang=ts&"
export * from "./projects-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports